import { render, staticRenderFns } from "./ShareCalculator.vue?vue&type=template&id=4af27be8"
import script from "./ShareCalculator.vue?vue&type=script&lang=js"
export * from "./ShareCalculator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports